import { z } from "zod";

// Bun inlines referenced `process.env.*` at build time. A var that is unset at
// build time stays as a literal `process.env.X` and throws "process is not
// defined" in the browser. Shim so unset vars read as `undefined` and give a zod
// default or a clean validation error instead of a ReferenceError.
(globalThis as Record<string, unknown>).process ??= { env: {} };

// NEVER write secrets here. The bundle is public.
const PublicEnvSchema = z.object({
	NODE_ENV: z.enum(["development", "production"]).default("development"),
	// The control plane, reached on this app's own origin rather than on
	// api.lawline.se. Two reasons, and the first is not cosmetic: the product's
	// Better Auth sets its cookie on `.lawline.se`, so it reaches every subdomain,
	// and putting a second Better Auth on the same origin as the product's means
	// two session cookies from different instances on one host. Same-origin also
	// removes CORS from the path entirely, leaving PLATFORM_ORIGIN as a second
	// line rather than the thing holding it up.
	//
	// Empty default: relative fetches resolve against wherever the bundle is
	// served, which is right in dev, in preview and in production without a
	// per-environment value. Set it only to point the portal at a different host.
	PUBLIC_API_BASE_URL: z.union([z.url(), z.literal("")]).default(""),
	PUBLIC_DOCS_BASE_URL: z.url().default("https://docs.lawline.se"),
});

const parsed = PublicEnvSchema.safeParse({
	NODE_ENV: process.env.NODE_ENV,
	PUBLIC_API_BASE_URL: process.env.PUBLIC_API_BASE_URL,
	PUBLIC_DOCS_BASE_URL: process.env.PUBLIC_DOCS_BASE_URL,
});

if (!parsed.success) {
	const details = parsed.error.issues
		.map((i) => `  ${i.path.join(".") || "(root)"}: ${i.message}`)
		.join("\n");
	throw new Error(`Invalid public environment configuration:\n${details}`);
}

export const env = {
	NODE_ENV: parsed.data.NODE_ENV,
	API_BASE_URL: parsed.data.PUBLIC_API_BASE_URL,
	DOCS_BASE_URL: parsed.data.PUBLIC_DOCS_BASE_URL,
};

export type PublicEnv = typeof env;
